import { useContext, useState } from 'react'
import { OtherContext } from '../../../context api/Others/OtherContext'
import { useRestApi } from '../../../lib/RestApi/useRestApi'
import { API_URL } from '../../../shared/actions'

export const useTrainingCategoryContent = () => {
  const [trainingCategoryContent, setTrainingCategoryContent] = useState(false)
  const { deleteNewTrainingCategoryContent, getNewTrainingCategoryContent } = useContext(OtherContext)
  const [loading, setLoading] = useState(false)
  const [paginate, setPaginate] = useState(false)

  const { ADD, GET_ALL, UPDATE, GET_SINGLE_DATA, DELETE } = useRestApi(setLoading, 'Training Category Content', 'ALL_TRAININGCATEGORYCONTENT', 'GET_ALL_TRAININGCATEGORYCONTENT')
  const {
    TRAININGCATEGORYCONTENT: { GET_ALL_TRAININGCATEGORYCONTENT, ADD_TRAININGCATEGORYCONTENT, EDIT_TRAININGCATEGORYCONTENT, GET_TRAININGCATEGORYCONTENT, DELETE_MANY_TRAININGCATEGORYCONTENT },
  } = API_URL

  const getAllTrainingCategoryContent = async (dto = {}) => {
    GET_ALL(GET_ALL_TRAININGCATEGORYCONTENT, setPaginate, getNewTrainingCategoryContent, dto)
  }

  const addTrainingCategoryContent = (dto) => {
    ADD(ADD_TRAININGCATEGORYCONTENT, dto)
  }

  const updateTrainingCategoryContent = (dto) => {
    UPDATE(EDIT_TRAININGCATEGORYCONTENT, dto)
  }

  const getTrainingCategoryContent = (dto) => {
    GET_SINGLE_DATA('GET_TRAININGCATEGORYCONTENT', setTrainingCategoryContent, dto._id)
  }

  const deleteManyTrainingCategoryContent = (dto, setSelected = () => {}) => {
    DELETE(DELETE_MANY_TRAININGCATEGORYCONTENT, dto, 'trainingCategoryContentId', setSelected, deleteNewTrainingCategoryContent, 'GET_ALL_TRAININGCATEGORYCONTENT')
  }

  return {
    addTrainingCategoryContent,
    getAllTrainingCategoryContent,
    getTrainingCategoryContent,
    trainingCategoryContent,
    updateTrainingCategoryContent,
    deleteManyTrainingCategoryContent,
    loading,
    paginate,
  }
}
